import { Box, Button, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

interface IFormInput {
  email: string;
  password: string;
}

interface Props {
  signIn: (email?: string, password?: string) => void;
  isSubmitting?: boolean;
}

const SignInForm = ({ signIn, isSubmitting }: Props) => {
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<IFormInput>({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const onSubmit = (data: IFormInput) => {
    signIn(data.email, data.password);
  };

  return (
    <form data-testid="form--sign-in" onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="email"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <TextField
            {...field}
            type="text"
            placeholder="Email"
            fullWidth={true}
            inputProps={{ 'data-testid': 'input--email' }}
            autoComplete="username"
          />
        )}
      />

      <Box py={2}>
        <Controller
          name="password"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              type="password"
              placeholder="Password"
              fullWidth={true}
              inputProps={{ 'data-testid': 'input--password' }}
              autoComplete="current-password"
            />
          )}
        />
      </Box>

      <Button
        disabled={!isValid || isSubmitting}
        data-testid="button--submit"
        size="large"
        fullWidth={true}
        variant="contained"
        type="submit"
      >
        {isSubmitting ? 'Signing In...' : 'Sign In'}
      </Button>
    </form>
  );
};

export default SignInForm;
